import httpRequest from '../../utils/request';

const list = async (params = {}) => {
  const response = await httpRequest.get('/suppliers', { params });
  return response.data; // { items, total, page, limit }
};

const create = async (data) => {
  const response = await httpRequest.post('/suppliers', data);
  return response.data;
};

const update = async (id, data) => {
  const response = await httpRequest.put(`/suppliers/${id}`, data);
  return response.data;
};

const remove = async (id) => {
  const response = await httpRequest.delete(`/suppliers/${id}`);
  return response.data;
};

const supplierService = { list, create, update, remove };
export default supplierService;
